let protocol = location.protocol === "https:" ? "wss" : "ws";
let hostUrl = location.host;
export const config = {
    app_name: '新媒体实战教学平台',
    version: "",
    ws_url: process.env.NODE_ENV === "development" ? "ws://198.19.249.215:2388" : `${protocol}://${hostUrl}/wss`,
    webdriver_wss: process.env.NODE_ENV === "development" ? "ws://172.81.206.211:2348" : "wss://data.yikeos.net/wss"
}

export const randomWsUrl = (id) => {
    if (process.env.NODE_ENV  === "development") {
        protocol = "wss";
        hostUrl = "media.e-class.me";
    }
    const list = [
        //学校部署版，需要注释下面的三项
        `${hostUrl}/wss1`,
        `${hostUrl}/wss2`,
        `${hostUrl}/wss3`
        //学校部署版，需要打开下面的注释
        // "media.e-class.me/wss1",
        // "media.e-class.me/wss2",
        // "media.e-class.me/wss3",
    ];
    const index = Math.floor(Math.random() * list.length);


    return `${protocol}://${list[index]}?id=${id}`;
}
